module.exports = __webpack_public_path__ + "img/button_volna_an.fa10c4f3.svg";